import { render } from "./FormUser.vue?vue&type=template&id=586a4877&scoped=true"
import script from "./FormUser.vue?vue&type=script&lang=js"
export * from "./FormUser.vue?vue&type=script&lang=js"

import "./FormUser.vue?vue&type=style&index=0&id=586a4877&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586a4877"]])

export default __exports__